// Pure filter logic for MultiSelectFilter's in-dropdown search. Case-insensitive
// substring match on `label` (the visible text), trimmed. An empty/blank query
// returns every option unchanged (no constraint).

export function filterOptionsBySearch<T extends { label: string }>(
  options: T[],
  query: string,
): T[] {
  const q = query.trim().toLowerCase();
  if (q === '') return options;
  return options.filter((o) => o.label.toLowerCase().includes(q));
}
